// @flow

import * as React from 'react';

type Props = {
  children: React.Node,
  routeTo: (string, ?{}) => void,
};

const defaultContext = {
  routeTo: null,
};

const LinkContext = React.createContext(defaultContext);

export const useLink = () => React.useContext(LinkContext);

/**
 * React context that provides the `routeTo` function to `Link`
 * components to be able to do client side routing when needed
 */
const LinkProvider = ({ children, routeTo }: Props) => {
  return children ? (
    <LinkContext.Provider value={{ routeTo }}>
      {React.Children.only(children)}
    </LinkContext.Provider>
  ) : null;
};

export default LinkProvider;
